export enum AccessRoleKeyEnum {
  ACCESS_ROLE_KEYS = 'ACCESS_ROLE',
}

export enum AccessRoleValueEnum {
  NO_SUBMIT_VALUE = 'NO_SUBMIT',
}
